import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Gift, ChevronRight, ShoppingCart, Coins } from "lucide-react";

export const ProfileAuctionsTab = ({ user, myClaims }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      key="auctions"
      initial={{ opacity: 0, x: -10 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 10 }}
      className="space-y-5"
    >
      <button
        onClick={() => navigate("/rewards")}
        className="w-full bg-gradient-to-r from-[#FF6B35]/10 to-[#7000FF]/10 border border-[#FF6B35]/20 rounded-3xl p-5 flex items-center justify-between hover:border-[#FF6B35]/40 transition-all shadow-sm group"
        data-testid="rewards-shop-btn"
      >
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-xl bg-[#FF6B35]/15 flex items-center justify-center group-hover:scale-110 transition-transform">
            <Gift className="w-6 h-6 text-[#FF6B35]" />
          </div>
          <div className="text-left">
            <p className="font-heading font-bold text-sm text-card-foreground">Encheres en cours</p>
            <p className="text-[10px] text-muted-foreground">Mise sur des lots exclusifs d'artistes</p>
          </div>
        </div>
        <ChevronRight className="w-5 h-5 text-[#FF6B35] group-hover:translate-x-1 transition-transform" />
      </button>

      {myClaims.length > 0 && (
        <div className="bg-card border border-border rounded-3xl p-5 space-y-3 shadow-sm" data-testid="my-claims-section">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <ShoppingCart className="w-4 h-4 text-[#FF6B35]" />
              <h3 className="font-heading font-bold text-sm text-card-foreground">Encheres gagnees ({myClaims.length})</h3>
            </div>
          </div>
          <div className="space-y-2">
            {myClaims.map((claim) => (
              <div
                key={claim.id}
                className="flex items-center gap-3 p-3 rounded-2xl bg-white border border-border"
                data-testid={`profile-claim-${claim.id}`}
              >
                <div className="w-9 h-9 rounded-xl bg-[#7000FF]/10 flex items-center justify-center shrink-0">
                  <Gift className="w-4 h-4 text-[#7000FF]" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-heading font-bold text-xs text-card-foreground truncate">{claim.reward_title}</p>
                  <p className="text-[10px] text-muted-foreground">par {claim.artist_name}</p>
                </div>
                <div className="text-right shrink-0">
                  <p className="font-mono-credits font-bold text-xs text-[#FF6B35]">-{claim.price}</p>
                  <span className={`text-[9px] px-1.5 py-0.5 rounded-full ${
                    claim.status === "completed" ? "bg-emerald-50 text-emerald-500" :
                    claim.status === "pending" ? "bg-yellow-50 text-yellow-600" : "bg-muted text-muted-foreground"
                  }`}>
                    {claim.status === "pending" ? "En attente" : claim.status === "completed" ? "Termine" : claim.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <button
        onClick={() => navigate("/credits")}
        className="w-full bg-card border border-border rounded-3xl p-4 flex items-center justify-between hover:border-[#FF6B35]/30 transition-all shadow-sm group"
        data-testid="credits-shop-link"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#FF6B35]/10 flex items-center justify-center">
            <Coins className="w-5 h-5 text-[#FF6B35]" />
          </div>
          <div className="text-left">
            <p className="font-heading font-bold text-sm text-card-foreground">Acheter des credits</p>
            <p className="text-[10px] text-muted-foreground">Solde : {user.credits_balance} credits</p>
          </div>
        </div>
        <ChevronRight className="w-5 h-5 text-muted-foreground group-hover:translate-x-1 transition-transform" />
      </button>
    </motion.div>
  );
};
